
<template>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="0"
    :loop="true"
    navigation
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <img :src="item.pic" :alt="item.alt || ''">
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
// Swiper 初期化前・画像ロード前からレイアウトを確保。
// 本番利用例: /products/<id>/ の demo_0X.jpg が 800x500 (8:5)。
.swiper-slide {
  aspect-ratio: 800 / 500;
  overflow: hidden;
}
img{
  width: 100%;
  height: 100%;
  aspect-ratio: 800 / 500;
  object-fit: cover;
  display: block;
}

</style>

<script>
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    }
  },
}
</script>
